import { memo, ReactNode } from "react";
import { useAiSlidePanel } from "../contexts/ai-slide-panel-context";
import * as styles from "../styles/ai-slide-panel-layout.module.css";

interface AiSlidePanelLayoutProps {
  children: ReactNode;
  panel: ReactNode;
  panelWidth?: "sm" | "md" | "lg";
}

export const AiSlidePanelLayout = memo(function AiSlidePanelLayout({
  children,
  panel,
  panelWidth = "sm",
}: AiSlidePanelLayoutProps) {
  const { isOpen } = useAiSlidePanel();

  const widthClass = {
    sm: styles.panelSmall,
    md: styles.panelMedium,
    lg: styles.panelLarge,
  }[panelWidth];

  return (
    <div
      className={`${styles.layoutContainer} ${widthClass} ${isOpen ? styles.layoutContainerOpen : ""}`}
    >
      <div className={styles.mainContent}>{children}</div>

      <div className={styles.slidePanel}>{panel}</div>
    </div>
  );
});
